import { initializeApp, getApps, getApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyBEH7Si2rY8I29zmAJf2LBmVhjgtU9H74s",
  authDomain: "guialumis-8597a.firebaseapp.com",
  projectId: "guialumis-8597a",
  storageBucket: "guialumis-8597a.firebasestorage.app",
  messagingSenderId: "714910596535",
  appId: "1:714910596535:web:e0c897f9de4c7983337c32",
};

const VAPID_KEY = "BGJDTTJc3mA-Z6wKodoW-MjGBxI_5RlnaRfyVlq8zOKoNg4bYBYUj6GySufw2q5YiHNR0QzIJSYOsGpepmH4s6k";

// Pede permissão de notificação e devolve o token FCM do dispositivo, ou null
// se o usuário negar/o navegador não suportar (Firebase registra sozinho o SW
// dedicado em /firebase-messaging-sw.js, em scope próprio — não conflita com
// o service-worker.js de cache/PWA já registrado em "/").
export async function requestFcmToken() {
  if (!("Notification" in window) || !("serviceWorker" in navigator)) return null;
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") return null;
    const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
    const messaging = getMessaging(app);
    return await getToken(messaging, { vapidKey: VAPID_KEY });
  } catch (e) {
    console.warn("[LUMIS] Falha ao obter token FCM:", e);
    return null;
  }
}
